import { startOfTomorrow } from 'date-fns/startOfTomorrow';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

import type { AccountNumber, PaymentInterval } from '../../../../generated-types';
import { SelectedReceiver } from '../../SelectedReceiver';

export interface RecurringPaymentState {
    toAccount?: SelectedReceiver;
    fromAccount?: AccountNumber;
    amount?: number;
    note: string;
    ownText?: string;
    firstBankingDate: ZonedDate;
    firstPaymentDate: ZonedDate;
    lastPaymentDate?: ZonedDate;
    paymentInterval?: PaymentInterval;
    showFromAccounts: boolean;
    showToAccounts: boolean;
}

const tomorrow = getZonedDate(startOfTomorrow());

export const recurringPaymentInitialState: RecurringPaymentState = {
    toAccount: undefined,
    fromAccount: undefined,
    amount: undefined,
    note: '',
    firstBankingDate: tomorrow,
    firstPaymentDate: tomorrow,
    lastPaymentDate: undefined,
    paymentInterval: 'MONTHLY',
    showFromAccounts: false,
    showToAccounts: false,
};
